export default {"src":"/_next/static/media/logo3.11cc9e21.svg","height":131,"width":130,"blurWidth":0,"blurHeight":0};